import React from "react";
import { useNavigate } from "react-router-dom";
import "./Docs.css";
import {
  UnauthorisedPageSurface,
  PageWrapper,
} from "../components/layout/container/Container";

const GeneralPrivacyPolicy = () => {
  document.title = "Katch | Privacy Policy";

  const navigate = useNavigate();

  const handleContactSupportOnClick = () => {
    return navigate("/support");
  };

  return (
    <UnauthorisedPageSurface>
      <PageWrapper>
        <section className={"docs__section"}>
          <h1>Katch Privacy Policy</h1>
          <p>Last updated: November 22nd, 2025</p>

          <br />

          <p>
            Thank you for using <strong>Katch.one</strong>, a video streaming
            platform dedicated to local sports enthusiasts. We are committed to
            protecting your privacy and securing your personal information. This
            Privacy Policy explains how we collect, use, disclose, and safeguard
            your information when you use our website and mobile application
            (together, the <em>"Service"</em>). By accessing or using Katch.one,
            you agree to this Privacy Policy. If you do not agree with these
            terms, please refrain from using our Service.
          </p>

          <br />

          <h2>1. Information We Collect</h2>

          <br />

          <h3>1.1. Information You Provide</h3>
          <br />

          <p>
            When you register an account, subscribe to our services, or
            communicate with us, we may collect personal information such as
            your name, email address, username, password, billing information,
            and other details you voluntarily provide.
          </p>
          <br />

          <h3>1.2. Usage Information</h3>
          <br />

          <p>
            We may collect information about how you interact with Katch.one,
            including your browsing activities, the content you view, your IP
            address, device information, and other usage data.
          </p>
          <br />

          <h3>1.3. Cookies and Tracking Technologies</h3>
          <br />

          <p>
            We use cookies and similar tracking technologies to enhance your
            experience, analyse trends, and gather information about your
            preferences. You can manage cookie preferences through your browser
            settings.
          </p>
          <br />

          <h2>2. How We Use Your Information</h2>
          <br />

          <p>
            We may use the information we collect for the following purposes:
          </p>
          <br />

          <ul>
            <li>To provide and maintain Katch.one services.</li>
            <li>
              To personalise your experience and deliver relevant content.
            </li>
            <li>
              To communicate with you regarding your account, updates, and
              promotions.
            </li>
            <li>To analyse usage trends and improve our services.</li>
            <li>To detect and prevent fraud, security breaches, and abuse.</li>
            <li>To comply with legal obligations and enforce our policies.</li>
          </ul>
          <br />

          <h2>3. How We Share Your Information</h2>
          <br />

          <p>
            We may share your information with third parties in the following
            circumstances:
          </p>

          <br />

          <ul>
            <li>
              With service providers who assist us in operating Katch.one and
              providing services.
            </li>
            <li>
              In response to legal requests or to comply with applicable laws,
              regulations, or legal processes.
            </li>
          </ul>
          <br />

          <h2>4. Data Security</h2>
          <br />

          <p>
            We take reasonable measures to protect your information from
            unauthorized access, alteration, disclosure, or destruction.
            However, no method of transmission over the internet or electronic
            storage is 100% secure. Therefore, we cannot guarantee absolute
            security.
          </p>
          <br />

          <h2>5. Your Choices</h2>

          <br />

          <h3>5.1. Account Settings</h3>
          <br />

          <p>
            You can manage your account settings and preferences to control the
            information you provide and how it is used.
          </p>
          <br />

          <h3>5.2. Marketing Communications</h3>
          <br />

          <p>
            You can opt-out of receiving promotional emails or marketing
            communications by following the unsubscribe instructions provided in
            the emails or by contacting us directly.
          </p>
          <br />

          <h2>6. Children's Privacy</h2>
          <br />

          <p>
            Katch.one is not intended for children under the age of 13. We do
            not knowingly collect personal information from children under 13.
            If you believe we have inadvertently collected information from a
            child under 13, please contact us immediately.
          </p>
          <br />

          <h2>7. Updates to This Privacy Policy</h2>
          <br />

          <p>
            We may update this Privacy Policy from time to time. Any changes
            will be effective immediately upon posting the revised policy on
            Katch.one. We encourage you to review this Privacy Policy
            periodically for any updates.
          </p>
          <br />

          <h2>8. Contact Us</h2>
          <br />

          <p>
            If you have any questions, concerns, or feedback regarding this
            Privacy Policy or our privacy practices, please contact us at{" "}
            <a
              style={{
                color: "skyblue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={handleContactSupportOnClick}
            >
              support
            </a>{" "}
          </p>
        </section>
      </PageWrapper>
    </UnauthorisedPageSurface>
  );
};

export default GeneralPrivacyPolicy;
